import { Route, Switch } from 'react-router-dom';

import { AdminCenterTimeFilterProvider } from '../utils/contexts';
import { useCloudPlatformDiscovery, useEnv } from '../utils/hooks';
import { Error404Page } from './ErrorPage';
import DAIRedirect from './MLOps/DAIRedirect';
import MLOpsWorkspaceRedirect from './MLOps/MLOpsWorkspaceRedirect';
import WorkspaceRedirect from './Orchestrator/WorkspaceRedirect';
import { RoutePaths } from './RoutePaths';
import { ADMIN_CENTER_ROUTE_DEFINITIONS } from './Routes/adminCenterRouteDefinitions';
import { FEATURESTORE_ROUTE_DEFINITIONS } from './Routes/featurestoreRouteDefinitions';
import { MLOPS_ROUTE_DEFINITIONS } from './Routes/mlopsRouteDefinitions';
import { ORCHESTRATOR_ROUTE_DEFINITIONS } from './Routes/orchestratorRouteDefinitions';
import { ROUTE_DEFINITIONS } from './Routes/routeDefinitions';
import { applyRouteGuards } from './Routes/routeHelpers';

// Re-export RoutePaths for backward compatibility
export { RoutePaths };

export const Routes = () => {
  const env = useEnv();
  const cloudPlatformDiscovery = useCloudPlatformDiscovery();
  const featurestoreEnabled = Boolean(cloudPlatformDiscovery?.featurestoreApiUrl && env?.featureStoreEnabled);

  return (
    <Switch>
      <Route path={RoutePaths.ORCHESTRATOR_ENTRY}>
        <Switch>
          <Route exact path={RoutePaths.ORCHESTRATOR_ENTRY} render={() => <WorkspaceRedirect />} />
          {ORCHESTRATOR_ROUTE_DEFINITIONS.map((route, index) => (
            <Route
              key={`orchestrator-route-${index}`}
              path={route.path as string}
              exact={route.exact}
              render={(props) => applyRouteGuards(route, props)}
            />
          ))}
        </Switch>
      </Route>

      <Route path={RoutePaths.ADMIN_CENTER_ENTRY}>
        <AdminCenterTimeFilterProvider>
          <Switch>
            {ADMIN_CENTER_ROUTE_DEFINITIONS.map((route, index) => (
              <Route
                key={`admin-center-route-${index}`}
                path={route.path as string}
                exact={route.exact}
                render={(props) => applyRouteGuards(route, props)}
              />
            ))}
          </Switch>
        </AdminCenterTimeFilterProvider>
      </Route>

      <Route path={RoutePaths.MLOPS_ENTRY}>
        <DAIRedirect />
        <Switch>
          <Route exact path={RoutePaths.MLOPS_ENTRY} render={() => <MLOpsWorkspaceRedirect />} />
          {MLOPS_ROUTE_DEFINITIONS.map((route, index) => (
            <Route
              key={`mlops-route-${index}`}
              path={route.path as string}
              exact={route.exact}
              render={(props) => applyRouteGuards(route, props)}
            />
          ))}
        </Switch>
      </Route>

      {ROUTE_DEFINITIONS.map((route, index) => (
        <Route
          key={`route-${index}`}
          path={route.path as string}
          exact={route.exact}
          render={(props) => applyRouteGuards(route, props)}
        />
      ))}

      {!featurestoreEnabled
        ? null
        : FEATURESTORE_ROUTE_DEFINITIONS.map((route, index) => (
            <Route
              key={`featurestore-route-${index}`}
              path={route.path as string}
              exact={route.exact}
              render={(props) => applyRouteGuards(route, props)}
            />
          ))}

      <Route render={() => <Error404Page />} />
    </Switch>
  );
};
